import React, { useState } from 'react'
import styles from './TopicSelectionModal.module.css'
import bodyIcon from '../../assets/icons/body.svg'
import houseIcon from '../../assets/icons/houseWhite.svg'
import rainy from '../../assets/icons/rainy.svg'
import treeIcon from '../../assets/icons/whiteTree.svg'

export const topics = [
    {
      id: 'htp-house',
      title: '집 그림 테스트',
      subtitle: '집 그림 심리검사를 통해 마음의 상태를 확인해보세요.',
      description: '집·나무·사람 그림 심리검사를 통해 마음의 상태를 확인해보세요.',
      time: '예상 소요시간 : 15~30분',
      color: '#DBEAFE',
      iconBoxColor: '#9DAAFF',
      textColor: '#403AFF',
      borderColor: '#83B8FF',
      icon: houseIcon
    },
    {
      id: 'htp-tree',
      title: '나무 그림 테스트',
      subtitle: '나무 그림 심리검사를 통해 마음의 상태를 확인해보세요.',
      description: '사나무 그림 심리검사를 통해 마음의 상태를 확인해보세요.',
      time: '예상 소요시간 : 10~20분',
      color: '#DAFFDA',
      iconBoxColor: '#29B108',
      textColor: '#007B0E',
      borderColor: '#51B951',
      icon: treeIcon
    },
    {
      id: 'htp-human',
      title: '사람 그림 테스트',
      subtitle: '사람을 그린 후 인격과 대인관계를 확인할 수 있어요.',
      description: '사람을 그린 후 인격과 대인관계를 확인할 수 있어요.',
      time: '예상 소요시간 : 15~30분',
      color: '#EDE9FE',
      iconBoxColor: '#9333EA',
      textColor: '#9000F0',
      borderColor: '#C4B7FF',
      icon: bodyIcon
    },
    {
      id: 'pitr',
      title: '비와 사람 그림 테스트',
      subtitle: '경험과 사건을 그림 그림치료를을 통한치료를 해보세요.',
      description: '경험과 사건을 그림 그림치료를을 통한치료를 해보세요.',
      time: '예상 소요시간 : 15~30분',
      color: '#FFF1B8',
      iconBoxColor: '#FFC74D',
      textColor: '#926400',
      borderColor: '#C3AB4C',
      icon: rainy
    }
  ]

const TopicSelectionModal = ({ isOpen, onClose = () => {}, onTopicSelect }) => {
  const [selectedTopic, setSelectedTopic] = useState(null)

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic)
  }

  const handleStart = () => {
    if (selectedTopic) {
      onTopicSelect(selectedTopic)
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2>그림 주제 선택</h2>
          <p>어떤 주제로 그림을 그리시겠어요?</p>
        </div>

        <div className={styles.topicsGrid}>
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`${styles.topicCard} ${
                selectedTopic?.id === topic.id ? styles.selected : ''
              }`}
              style={{ backgroundColor: topic.color, borderColor : topic.borderColor}}
              onClick={() => handleTopicClick(topic)}
            >
              <div 
                className={styles.cardIcon}
                style={{
                  backgroundColor: topic.iconBoxColor,
                }}>
                  <img src={topic.icon} alt = "topic.icon" draggable={false}/>
              </div>
              <div 
                className={styles.cardContent}
                style={{
                  color: topic.textColor
                }}
                >
                  <h3 className={styles.cardTitle}>{topic.title}</h3>
                  <p className={styles.cardDescription}>{topic.subtitle}</p>
                  <span className={styles.cardTime}>{topic.time}</span>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <button 
            className={styles.startBtn} 
            onClick={handleStart}
            disabled={!selectedTopic}
          >
            시작하기
          </button>
        </div>
      </div>
    </div>
  )
}

export default TopicSelectionModal